import { COMMODITY_CATEGORY_TYPE } from '../../../Common';
import { DISPLAY_ITEM_ID } from '../../../redux/reducers/MasterInfoReducer';

// Productの[Create]と[Preview]共通で使う設定をまとめたい

export type AreaCheckItems = {
  title: string;
  itemId: DISPLAY_ITEM_ID;
  value?: string;
  type: 'radio' | 'id' | 'limit';
  linkParamNm?: string;
};

export const areaCheckItemsList: { [key: string]: AreaCheckItems[] } = {
  [COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI]: [
    { title: 'ファミリータイプ 1ギガ', itemId: DISPLAY_ITEM_ID.AREA_HIKARI_FAMILY_1G, type: 'radio', linkParamNm: 'family01g' },
    { title: 'ファミリータイプ 10ギガ', itemId: DISPLAY_ITEM_ID.AREA_HIKARI_FAMILY_10G, type: 'radio', linkParamNm: 'family10g' },
    { title: 'マンションタイプ 1ギガ', itemId: DISPLAY_ITEM_ID.AREA_HIKARI_APARTMENT_1G, type: 'radio', linkParamNm: 'apartment01g' },
    { title: 'マンションタイプ 10ギガ', itemId: DISPLAY_ITEM_ID.AREA_HIKARI_APARTMENT_10G, type: 'radio', linkParamNm: 'apartment10g' },
    { title: '照合ID', itemId: DISPLAY_ITEM_ID.AREA_HIKARI_VERIFY_ID, type: 'id', linkParamNm: 'id' },
    { title: '期限日', itemId: DISPLAY_ITEM_ID.AREA_HIKARI_VERIFY_ID_LIMIT, type: 'limit', linkParamNm: 'expirationDate' },
  ],
  [COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI_PLUS]: [
    { title: '1/2.5ギガ', itemId: DISPLAY_ITEM_ID.SB_HIKARI_PLUS_AREA_CHECK_RESULT_1G, type: 'radio', linkParamNm: 'family01g' },
    { title: '10ギガ', itemId: DISPLAY_ITEM_ID.SB_HIKARI_PLUS_AREA_CHECK_RESULT_10G, type: 'radio', linkParamNm: 'family10g' },
    { title: '照合ID', itemId: DISPLAY_ITEM_ID.SB_HIKARI_PLUS_REFERENCE_ID, type: 'id', linkParamNm: 'id' },
    { title: '期限日', itemId: DISPLAY_ITEM_ID.SB_HIKARI_PLUS_REFERENCE_ID_DEADLINE, type: 'limit', linkParamNm: 'expirationDate' },
  ],
  [COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR]: [
    { title: '4G', itemId: DISPLAY_ITEM_ID.AREA_AIR_CHECK_4G, type: 'radio', linkParamNm: 'fourG' },
    { title: '5G', itemId: DISPLAY_ITEM_ID.AREA_AIR_CHECK_5G, type: 'radio', linkParamNm: 'fiveG' },
    { title: '照合ID', itemId: DISPLAY_ITEM_ID.AREA_AIR_VERIFY_ID, type: 'id', linkParamNm: 'id' },
    { title: '期限日', itemId: DISPLAY_ITEM_ID.AREA_AIR_VERIFY_ID_LIMIT, type: 'limit', linkParamNm: 'expirationDate' },
  ],
  [COMMODITY_CATEGORY_TYPE.HOME_PHONE]: [
    { title: '新規発番', itemId: DISPLAY_ITEM_ID.AREA_DENWA_CHECK_NEW_NUMBER, type: 'radio', linkParamNm: 'newNumber' },
    {
      title: '番号ポータビリティ/同番サ変',
      itemId: DISPLAY_ITEM_ID.AREA_DENWA_CHECK_NUMBER_PORTABILITY,
      type: 'radio',
      linkParamNm: 'numberPortability',
    },
    { title: '照合ID', itemId: DISPLAY_ITEM_ID.AREA_DENWA_VERIFY_ID, type: 'id', linkParamNm: 'id' },
    { title: '期限日', itemId: DISPLAY_ITEM_ID.AREA_DENWA_VERIFY_ID_LIMIT, type: 'limit', linkParamNm: 'expirationDate' },
  ],
};
